import React from 'react';
import './LandingPage.css';
import ramada from '../assets/ramada.jpg';
import mrgamb from '../assets/mrgamb.png';
import etalleProfile from '../assets/etalle.jpg';
import betist from '../assets/betist.jpg';

const LandingPage = () => {
  // Ana yönlendirme kutuları
  const mainBoxes = [
    {
      id: 1,
      imageUrl: mrgamb,
      link: 'https://tinyurl.com/MrGambPrincess',
      title: 'Mr. Gamb'
    },
    {
      id: 2,
      imageUrl: betist,
      link: 'https://cutt.ly/nrXNHEBH',
      title: 'Her Alanda Geçerli 1.000₺ Nakit Bonus Anında Hesabında'
    }
  ];

  // Sosyal medya linkleri (küçük ikonlar)
  const socialLinks = [
    {
      id: 1,
      name: 'Instagram',
      url: 'https://www.instagram.com/princesetalle?igsh=cjFuNmo1dTB0eDM%3D&utm_source=qr',
      icon: 'https://cdn-icons-png.flaticon.com/512/174/174855.png',
      color: '#E4405F'
    },
    {
      id: 2,
      name: 'Youtube',
      url: 'https://youtube.com/@etalleofficiall?si=ZIHNTT-l_MJqvrxy',
      icon: 'https://cdn-icons-png.flaticon.com/512/174/174883.png',
      color: '#E4405F'
    },
    {
      id: 3,
      name: 'YouTube',
      url: 'https://youtube.com/@etallewin?si=GI7egm6JM_91OJQR',
      icon: 'https://cdn-icons-png.flaticon.com/512/174/174883.png',
      color: '#FF0000'
    },
    {
      id: 4,
      name: 'Telegram',
      url: 'https://t.me/princesetalleofficial',
      icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png',
      color: '#0088CC'
    },
    {
      id: 5,
      name: 'Telegram Sohbet',
      url: 'https://t.me/Princesetalle2',
      icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png',
      color: '#0088CC'
    },
    {
      id: 6,
      name: 'TikTok',
      url: 'https://www.tiktok.com/@etalleofficial',
      icon: 'https://cdn-icons-png.flaticon.com/512/3046/3046121.png',
      color: '#000000'
    }
  ];

  const handleClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="landing-page">
      {/* ETALLE Başlığı ve Profil Fotoğrafı */}
      <div className="etalle-title-container">
        <div className="etalle-header">
          <div className="etalle-profile-container">
            <img
              src={etalleProfile}
              alt="Etalle Profile"
              className="etalle-profile-image"
            />
          </div>
          <div className="etalle-text-section">
            <h1 className="etalle-title">ETALLE</h1>
            <p className="etalle-subtitle">Güvenilir ve Kaliteli Hizmet</p>
          </div>
        </div>
      </div>

      {/* Ana yönlendirme kutuları üstte */}
      <div className="main-boxes-container">
        {mainBoxes.map(box => (
          <div
            key={box.id}
            className="main-box"
            onClick={() => handleClick(box.link)}
            style={{ backgroundImage: `url(${box.imageUrl})` }}
          >
            <div className="main-box-overlay">
              <h3 className="main-box-title">{box.title}</h3>
              <span className="main-box-arrow">→</span>
            </div>
          </div>
        ))}
      </div>

      {/* Sosyal medya ikonları altta (küçük) */}
      <div className="social-icons-bar">
        {socialLinks.map(link => (
          <div
            key={link.id}
            className="social-icon-item"
            onClick={() => handleClick(link.url)}
            style={{ '--hover-color': link.color }}
            title={link.name}
          >
            <img
              src={link.icon}
              alt={link.name}
              className="social-small-icon"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandingPage;
